/* html protection to avoid scripts */
const htmlRegexes = [
  /&/g,
  /</g,
  />/g,
  /'/g,
  /'/g
];

function isFishy(str: string): boolean {
  for (const r of htmlRegexes) {
    if (str.search(r) !== -1) {
      return true;
    }
  }
  return false;
}

function sanitize(str: string): string {
  if (isFishy(str)) {
    for (const r of htmlRegexes) {
      str = str.replace(r, '');
    }
  }
  return str;
}

const stringHelper = {
  sanitize,
  isFishy
};
export default stringHelper;
